define(['handlebars', 'i18next', 'moment', 'js-cookie'], function(handlebars, i18next, moment, jsCookie) {

	return function(key, timeFormat) {

		moment.locale(jsCookie.get('locale'));
		return new handlebars.SafeString(moment.utc(key).local().format('DD MMMM YYYY'));
	}
});